import Heading from 'shopper/components/Heading';

import Achievement from './Achievement';

const ACHIEVEMENTS = [
  {
    icon: 'group',
    subtitle: 'Usuários cadastrados',
    title: '3M+',
  },
  {
    icon: 'visibility',
    subtitle: 'Views por mês',
    title: '5M+',
  },
  {
    icon: 'verified',
    subtitle: 'Ofertas por dia',
    title: '700+',
  },
  {
    icon: 'rss-feed',
    subtitle: 'Leitores do Blog',
    title: '650K+',
  },
  {
    icon: 'instagram',
    subtitle: 'Usuários no Instagram',
    title: '160K+',
  },
];

const Achievements = () => (
  <section className="flex flex-col items-center gap-x-6 md:flex-row">
    <Heading
      className="mb-6 text-center text-neutral-low-400 md:mb-0 md:text-start"
      size="size2"
    >
      Nossos{' '}
      <Heading as="span" className="text-gradient-highlight" size="size2">
        números <br /> dizem mais
      </Heading>{' '}
      sobre nós
    </Heading>
    <div className="flex w-full max-w-[924px] flex-col items-center justify-center gap-y-7 rounded-5 bg-neutral-high-200 p-8 dark:bg-neutral-low-400 md:flex-row md:items-start md:justify-between md:gap-x-6 md:gap-y-0">
      {ACHIEVEMENTS.map(({ icon, subtitle, title }) => (
        <Achievement
          key={title}
          icon={icon}
          subtitle={subtitle}
          title={title}
        />
      ))}
    </div>
  </section>
);

export default Achievements;
